export const MuiChip = {
  styleOverrides: {
    root: { color: 'rgb(139, 148, 158)', backgroundColor: 'rgba(110, 118, 129, 0.4)' }
  },
  defaultProps: {
    // color: 'primary',
  }
}
